// src/utils/locationUtils.js

export const isWithinRange = (lat1, lon1, lat2, lon2, radiusKm = 0.5) => {
  console.log("Latitude 1:", lat1);
  console.log("Longitude 1:", lon1);
  console.log("Latitude 2:", lat2);
  console.log("Longitude 2:", lon2);
  console.log("Radius in KM:", radiusKm);
  const R = 6371; // Earth radius in KM
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  console.log("Distance:", distance, "km");
  console.log("Radius:", radiusKm, "km");
  console.log("Is within range:", distance <= radiusKm);

  return distance <= radiusKm;
};
